<template>
  <v-dialog v-model="dialog" persistent max-width="500" :fullscreen="$vuetify.breakpoint.xsOnly">
    <template v-slot:activator="{ on, attrs }">
      <v-btn small dark v-bind="attrs" v-on="on" class="pb-0" color="success">Create Pay</v-btn>
    </template>

    <v-card tile>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Create Pay</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="submit"> Save </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text class="mt-5">
        <div class="text-h4 mb-2">{{ employee.name }}</div>
        <!-- <v-row>
          <v-col cols="12" class="pb-0">
            <div class="text-h4">{{ employee.name }}</div>
          </v-col>
          <v-col class="py-0">
            <div class="body-1">
              Pay: <strong>{{ grandTotal | currency }}</strong>
            </div>
          </v-col>
          <v-col class="py-0" cols="12">
            <v-flex>
              <span>Rate: {{ employee.hourlyRate | currency }}</span>
            </v-flex>

            <v-flex
              v-if="
                employee.metadata &&
                employee.metadata.timeClockLogin &&
                employee.metadata.timeClockLogin.workingHours
              "
            >
              <span
                >Daily Working Hours:
                {{ employee.metadata.timeClockLogin.workingHours }} Hr</span
              >
            </v-flex>

            <v-flex v-else>
              <span>Daily Working Horus: Not Set (default 12)</span>
            </v-flex>

            <v-flex>
              <span>Worked Hours </span>
              <span>{{ secondsToHms(totalSeconds) }}</span>
            </v-flex>
            <div>
              <v-flex>
                <span>Supposed To Work </span>
                <span>{{ secondsToHms(workingSeconds) }}</span>
              </v-flex>
              <v-flex v-if="diffTime() > 0">
                <v-chip label color="red" small text-color="white">
                  Short: {{ secondsToHms(diffTime()) }}
                </v-chip>
              </v-flex>
              <v-flex v-else>
                <v-chip label color="green" small text-color="white">
                  Over: {{ secondsToHms(Math.abs(diffTime())) }}
                </v-chip>
              </v-flex>
            </div>
          </v-col>
          <v-card class="mt-2" outlined width="100%">
            <v-card-text>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <div>Date</div>
                  <DateTimeTextField
                    hide-details
                    v-model="pay.entryAt"
                    :initDate="pay.entryAt"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    prefix="$"
                    dense
                    outlined
                    clearable
                    class="al-r"
                    type="number"
                    v-model="pay.amount"
                    hide-details=""
                    label="Amount"
                    @focus="$event.target.select()"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-textarea
                    label="Note"
                    outlined
                    clearable
                    v-model="pay.note"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-row> -->
        <v-row>
          <!-- Left Side: Regular Pay Details -->
          <v-col cols="6" class="pb-0">
            

            <!-- Pay Amount -->
            <v-flex>
              <span>Pay: <strong>{{ grandTotal | currency }}</strong></span>
            </v-flex>

            <!-- Hourly Rate -->
            <v-flex>
              <span>Rate: <strong>{{ employee.hourlyRate | currency }}</strong></span>
            </v-flex>

            <!-- Daily Working Hours -->
            <v-flex v-if="employee.metadata &&
              employee.metadata.timeClockLogin &&
              employee.metadata.timeClockLogin.workingHours">
              <span>Daily Working Hours: <strong>{{ employee.metadata.timeClockLogin.workingHours }} Hr</strong></span>
            </v-flex>
            <v-flex v-else>
              <span>Daily Working Hours: <strong>Not Set (default 12)</strong></span>
            </v-flex>

            <!-- Worked Hours -->
            <v-flex>
              <span>Worked Hours: <strong>{{ secondsToHms(totalSeconds) }}</strong></span>
            </v-flex>

            <!-- Supposed to Work vs. Short/Overtime -->
            <div>
              <v-flex>
                <span>Supposed To Work: <strong>{{ secondsToHms(workingSeconds) }}</strong></span>
              </v-flex>
              <v-flex v-if="diffTime() > 0">
                <v-chip label color="red" small text-color="white">
                  Short: {{ secondsToHms(diffTime()) }}
                </v-chip>
              </v-flex>
              <v-flex v-else>
                <v-chip label color="green" small text-color="white">
                  Over: {{ secondsToHms(Math.abs(diffTime())) }}
                </v-chip>
              </v-flex>
            </div>
          </v-col>

          <!-- Right Side: Overtime & Pay Breakdown -->
          <v-col cols="6" class="text-right">
            <v-layout column fill-height align-content-space-around>

              <!-- Overtime Section -->
              <v-flex v-if="employee.payOverTime">
                <v-chip label color="blue" small text-color="white">
                  Overtime Active
                </v-chip>
                <v-flex>
                  <span>Overtime Starts After: <strong>{{ employee.startOverTime }} Hours</strong></span>
                </v-flex>
                <v-flex v-if="overtimeHours > 0">
                  <span>Overtime Hours: <strong>{{ secondsToHms(overtimeHours) }}</strong></span>
                </v-flex>
                <v-flex>
                  <span>Overtime Rate: <strong>{{ employee.overTimeRate | currency }}</strong></span>
                </v-flex>
              </v-flex>

              <!-- Pay Breakdown -->
              <v-flex>
                <v-layout column>
                  <v-flex>
                    <h3>Regular Pay: <strong>{{ regularPay | currency }}</strong></h3>
                  </v-flex>
                  <v-flex v-if="employee.payOverTime && overtimeHours > 0">
                    <h3>Overtime Pay: <strong>{{ overtimePay | currency }}</strong></h3>
                  </v-flex>
                  <v-flex>
                    <h2>Total Pay: <strong>{{ totalPayWithOvertime | currency }}</strong></h2>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-col>

          <!-- Payment Entry Section -->
          <v-col cols="12">
            <v-card class="mt-2" outlined width="100%">
              <v-card-text>
                <v-row>
                  <v-col cols="12" class="pb-0">
                    <div>Date</div>
                    <DateTimeTextField hide-details v-model="pay.entryAt" :initDate="pay.entryAt" />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field prefix="$" dense outlined clearable class="al-r" type="number" v-model="pay.amount"
                      hide-details="" label="Amount" @focus="$event.target.select()"></v-text-field>
                  </v-col>
                  <v-col>
                    <v-textarea label="Note" outlined clearable v-model="pay.note"></v-textarea>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
// import timeClockService from "@/modules/TimeClock/service";
import DateTimeTextField from "@/components/DateTimeTextField.vue";
import payService from "@/modules/Pay/service";

export default {
  props: ["employee", "grandTotal", "period", "totalSeconds", "workingSeconds", "overtimeHours","regularPay","overtimePay","totalPayWithOvertime"],
  data: (vm) => ({
    dialog: false,
    loading: false,
    pay: {
      entryAt: vm.$moment(),
      amount: 0,
      note: null,
      PaidToEmployeeId: vm.employee.id,
    },
  }),
  components: {
    DateTimeTextField,
  },
  watch: {
    dialog(val) {
      if (val) {
        this.pay.amount = this.grandTotal.toFixed(2);
      }
    },
  },
  methods: {
    async submit() {
      console.log("pay", this.pay);
      // console.log("employee", this.employee);
      // console.log("employee", this.employee.TimeClocks.length);
      // return false
      let timeClock = [];
      await Promise.all(
        this.employee.TimeClocks.map((row) => {
          if (row.status === "clockedOut") timeClock.push(row.id);
        })
      );
      this.pay.metadata = {
        totalSeconds: this.totalSeconds,
        hourlyRate: this.employee.hourlyRate,
        payOverTime: this.employee.payOverTime,
        startOverTime: this.employee.startOverTime,
        overTimeRate: this.employee.overTimeRate,
        workingSeconds: this.workingSeconds,
        overtimeHours: this.overtimeHours,
        regularPay: this.regularPay,
        overtimePay: this.overtimePay,
        totalPayWithOvertime: this.totalPayWithOvertime
      }
      this.pay.timeClock = timeClock;
      console.log("time clock", this.pay);
      return payService.create(this.pay).then(() => {
        // this.$toast.success("Payment Receive Saved!", {timeout: 2000});
        this.dialog = false;
        this.$emit("submit");
      });
    },
    diffTime() {
      let value = this.workingSeconds - this.totalSeconds;
      return value;
    },
    close() {
      this.reset();
      this.dialog = false;
    },
    secondsToHms(d) {
      d = Number(d);
      let h = Math.floor(d / 3600);
      let m = Math.floor((d % 3600) / 60);
      let s = Math.floor((d % 3600) % 60);

      // var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
      // var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
      // var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";

      let hDisplay = h > 0 ? h + " h, " : "";
      let mDisplay = m > 0 ? m + " m, " : "";
      let sDisplay = s > 0 ? s + " s " : "";

      return hDisplay + mDisplay + sDisplay;
    },
    // submit() {
    //   this.loading = true;
    //   this.timeClock.EmployeeId = this.selectedEmployee.id;

    //   timeClockService
    //     .create(this.timeClock)
    //     .then(() => {
    //       this.dialog = false;
    //       this.$emit("submit");
    //       this.loading = false;
    //     })
    //     .catch((err) => {
    //       this.$emit("error", err);
    //       this.loading = false;
    //       // console.log("err :: ", err);
    //     });
    // },
  },
};
</script>

<style scoped></style>